var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUsers = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.016,32h-22a5.006,5.006,0,0,1-5-5V5a5.006,5.006,0,0,1,5-5h5.073a1,1,0,0,1,0,2H5.018a3,3,0,0,0-3,3V27a3,3,0,0,0,3,3h22a3.005,3.005,0,0,0,3-3v-4a3,3,0,0,0-3-2.995H8.995A3,3,0,0,0,6,22.995v4a1,1,0,0,1-2,0v-4A5,5,0,0,1,8.995,18H27.022a5,5,0,0,1,5,4.995v4A5.008,5.008,0,0,1,27.016,32Z",
    transform: "translate(-1.018 -1)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.018,7.083a1,1,0,0,1-1-1V5a3,3,0,0,0-3-3h-1.06a1,1,0,1,1,0-2h1.06a5.006,5.006,0,0,1,5,5V6.083A1,1,0,0,1,31.018,7.083Z",
    transform: "translate(-1.018 -1)",
    fill: "current"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(9.982)",
    fill: "current"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users.16122ebc.svg";
export { ForwardRef as ReactComponent };